import type { Snack } from "@/lib/gql/__generated__/graphql";

import type { DesignSnackFormBaseModel } from "../type";

type Props = {
	snackData: Snack;
};

export const serverModelToInputModel = ({ snackData }: Props): DesignSnackFormBaseModel["InputModel"] => {
	const {
		hotelID,
		availablePlansForHotel,
		description,
		snack,
		snackType,
		slug,
		ownerType,
		/**
		 * 旧 API では 保存時に isPublished = true としていたが、移行後はその処理が考慮されていなかったので、
		 * フロント側で InputModel に変換する際に差分を吸収している。
		 */
		// isPublished, // 常に公開する
		isParentTemplate,
		thumbnail,
		title,
		uuid,
	} = snackData;

	const inputModel: DesignSnackFormBaseModel["InputModel"] = {
		hotelID,
		availablePlansForHotel,
		description,
		snack,
		snackType,
		slug,
		ownerType,
		isPublished: true, // 常に公開する
		isParentTemplate,
		thumbnail,
		title,
		uuid,
	} satisfies DesignSnackFormBaseModel["InputModel"];

	return inputModel;
};
